import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import BookmarkListForm from '@src/features/company/bookmarks/BookmarkListForm';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyBookmarkList() {
  return (
    <CompanyGuard canService={[SERVICE.ENTERPRISE_PORTAL]}>
      <CompanyDefaultLayout pageName='bookmarks'>
        <CommonHelmet />
        <BookmarkListForm />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyBookmarkList;
